import React from "react";
import { graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import Seo from "../components/Seo";
import Layout from "../components/Layout";
import ProjectButtons from "../components/Buttons/ProjectButtons";

import { FaGithub, FaHome } from "react-icons/fa";

const Projects = ({ data }) => {
  const projects = data.allAirtable.nodes;
  return (
    <Layout>
      <Seo title="Projects" />
      <header className="projects-hero">
        <div className="section-title">
          <h1>my projects</h1>
          <div className="underline"></div>
        </div>
      </header>
      <ProjectButtons />
      <section className="section">
        <div className={`section-center projects-page-center`}>
          {projects.map((project, index) => {
            const { title, description, source, link, image } = project.data;
            return (
              <article key={index} className="single-project">
                <div className="project-container">
                  <GatsbyImage
                    image={getImage(image.localFiles[0])}
                    alt={title}
                  />
                  <a href={link} className="project-icon">
                    <FaHome />
                  </a>
                </div>
                <div className="project-details">
                  <h4>{title}</h4>
                  <p>{description}</p>
                  <div className="project-footer">
                    <span>
                      <FaGithub />
                    </span>
                    <a href={source}>source code</a>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </section>
    </Layout>
  );
};

export const query = graphql`
  {
    allAirtable(filter: { table: { eq: "Projects" } }) {
      nodes {
        data {
          title
          description
          source
          link
          image {
            localFiles {
              childImageSharp {
                gatsbyImageData(placeholder: TRACED_SVG, layout: CONSTRAINED)
              }
            }
          }
        }
      }
    }
  }
`;

export default Projects;
